module.exports = __webpack_public_path__ + "img/1-4.528d2cf7.png";